import { CommonModule } from '@angular/common';
import { Component, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestQueryPayload, Table } from '@cureskin/api-client';
import { AppConfig } from 'src/app/app.config';
import { Broadcaster } from 'src/components/broadcaster';
import { InputImageUploadModule } from 'src/components/input/input-image-upload';
import { LanguageStringSelectionModule } from 'src/components/language-string/language-string-selection';
import { ConnectionService } from 'src/services/connection-service';

@Component({
  selector: 'hero-ingredient-edit',
  imports: [CommonModule, LanguageStringSelectionModule, FormsModule, InputImageUploadModule, LanguageStringSelectionModule],
  templateUrl: './hero-ingredient-edit.component.html',
})
export class HeroIngredientEditComponent {
  heroIngredient: Table.HeroIngredient;
  nameLanguageStrings: Array<Table.LanguageString> = [];
  descriptionLanguageStrings: Array<Table.LanguageString> = [];
  heroIngredientName: string = '';
  heroIngredientDescription: string = '';
  priority: number = 0;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly conn: ConnectionService,
    private readonly broadcastService: Broadcaster,
    private readonly appConfig: AppConfig,
    private readonly router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    this.subscribeToUrlQueryParams();
    this.fetchLanguageStrings();
    this.heroIngredientName = this.heroIngredient?.get('name');
  }

  subscribeToUrlQueryParams(): void {
    this.route.data.subscribe((data: any) => {
      if (data?.heroIngredient) {
        this.heroIngredient = data?.heroIngredient;
        this.heroIngredient.set('image', [this.heroIngredient?.get('image')]);
        this.priority = this.heroIngredient?.get('priority');
      } else {
        this.heroIngredient = new Table.HeroIngredient();
      }
    });
  }

  async fetchLanguageStrings(): Promise<void> {
    const tags = ['hero-ingredient-title', 'hero-ingredient-description'];
    const languageStringTags = await this.conn.fetchLanguageStringTags({ tags });
    const payload: RequestQueryPayload<Table.LanguageString> = {
      where: { tags: { $in: languageStringTags } },
      project: ['en'],
    };
    this.nameLanguageStrings = await this.conn.findLanguageStrings(payload);
  }

  onPriorityChange(event: any): void {
    this.heroIngredient.set('priority', event);
  }

  async saveHeroIngredient(): Promise<void> {
    const image = this.heroIngredient?.get('image');
    if (image[0]) {
      this.heroIngredient.set('image', image[0]);
    }
    this.heroIngredient.set('priority', this.priority);

    const heroIngredientAlreadyExists = await this.conn.findHeroIngredient({ where: { nameLanguageString: this.heroIngredient.get('nameLanguageString') }});
    if (heroIngredientAlreadyExists && heroIngredientAlreadyExists?.id !== this.heroIngredient?.id) {
      this.broadcastService.broadcast('NOTIFY', { message: 'Hero Ingredient with this name already exists', type: this.appConfig.Shared.Toast.Type.ERROR });
      return;
    }
    await this.heroIngredient.save();
    this.broadcastService.broadcast('NOTIFY', { message: 'Hero Ingredient created successfully', type: this.appConfig.Shared.Toast.Type.SUCCESS });
    this.router.navigate(['/products/catalogs/hero-ingredient']);
  }
}
